import React from 'react';

interface SpinnerProps {
  size?: 'xtrasmall' | 'small' | 'medium' | 'large' | number;
  color?: string;
  className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ 
  size = 'small', 
  color = '#f97316', 
  className = '' 
}) => {
  // Handle custom pixel sizes
  const getSpinnerSize = () => {
    if (typeof size === 'number') {
      return `${size}px`;
    }
    
    switch (size) {
      case 'xtrasmall': return '20px';
      case 'small': return '30px';
      case 'medium': return '40px';
      case 'large': return '50px';
      default: return '30px';
    }
  };

  const spinnerSize = getSpinnerSize();
  const borderColor = color || '#f97316';
  const secondaryColor = '#e0f2fe'; // light blue

  const spinnerStyle = {
    width: spinnerSize,
    height: spinnerSize,
    borderRadius: '50%',
    border: '3px solid',
    borderColor: secondaryColor,
    borderRightColor: borderColor,
    animation: 'spinner-rotate 1s linear infinite'
  };

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div
        style={spinnerStyle}
        role="status"
        aria-label="Loading"
      >
        <span className="sr-only">Loading...</span>
      </div>
      <style>{`
        @keyframes spinner-rotate {
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};

export default Spinner;
